import GlassCard from '../../GlassCard';
import SectionHeader from '../../ui/SectionHeader';
import SkillCategory from '../skills/SkillsCategory';
import { skillCategoriesData } from '../../../assets/data/skillsData';

export default function Skills() {
  return (
    <section id="skills" className="min-h-screen flex items-center justify-center px-4 py-20">
      <div className="max-w-4xl w-full">
        <GlassCard className="border-emerald-400/30">
          <SectionHeader title="Technical Skills" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {skillCategoriesData.map((category, index) => (
              <SkillCategory 
                key={index} 
                category={category} 
              />
            ))}
          </div>
        </GlassCard>
      </div>
    </section>
  );
}